import React from 'react'
import styles from './Footer.module.scss'

const Footer = () => {

    const footerList1 = [
        { name: '서비스명 똑똑'},
        { name: '대표자명  정민규'},
        { name: '사업자등록번호  881-88-02079'},
        { name: '주소  광주 북구 첨단과기로208번길 43-22 와이어스파크 B동 2201호'},
        { name: '전화 010-9715-7650'},
        
    ];

    const footerList2 = [
        { name: '서비스 이용약관'},
        { name: '개인정보 취급방침'},
    ]
    const footerList3 = [
        { name: 'Copyright ⓒ 2024 DDOKDDOK'},
    ]

    return (
        <div className={styles.footer}>
            <div className={styles.wrap}>
                <div className={styles.logo} />
                <ul className={`${styles.footer_list} body4 medium gs6`}>
                    {footerList1.map((element, index)=>{
                        return <li key={element.name}>{element.name}</li>
                    })}
                </ul>
                <ul className={`${styles.footer_list} body4 bold gs6`}>
                    {footerList2.map((element, index)=>{
                        return <li key={element.name}>{element.name}</li>
                    })}
                </ul>
                <ul className={`${styles.footer_list} body4 medium gs6`}>
                    {footerList3.map((element, index)=>{
                        return <li key={element.name}>{element.name}</li>
                    })}
                </ul>
            </div>
        </div>
    )
}

export default Footer
